import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { App } from './App';
render(<ChakraProvider data-id="element-1183">
    <App data-id="element-1184" />
  </ChakraProvider>, document.getElementById('root'));